angular
    .module('app')
    .component('winbackOffers', {
        templateUrl: '/templates/pages/winback-offers/winback-offers.html',
        controller: 'WinbackOffersController',
        controllerAs: 'vm',
    });